import $ = require('jquery');

export = {
    /**
     * Checks recursively if the passed element or one of its parents has fixed position
     * @param {jQuery|String|HTMLElement} selector
     * @returns {boolean}
     */
    isFixedPosition(selector: string|HTMLElement|JQuery) {
        let $elem = $(selector);
        let targetIsFixed = $elem.parents().add($elem).filter((i, elem) => {
            return $(elem).css('position') === 'fixed';
        }).length;

        return targetIsFixed > 0;
    }
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/dom.ts
 **/